import React from "react";

import asIcon from "./asIcon";

export default asIcon(() =>
  (<g>
    <path fill="#25D366" d="M22 91.4L2.8 99.7l8-18.7A50 50 0 1 1 22 91.4z" />
    <path fill="#FFF" d="M39.4 31.9c-.8-1.8-1.6-1.8-2.4-1.8h-2a4 4 0 0 0-2.8 1.3c-1 1.1-3.7 3.6-3.7 8.8 0 5.2 3.8 10.3 4.3 11 .5.7 7.3 11.8 18.1 16 9 3.5 10.8 2.8 12.7 2.7 1.9-.2 6.3-2.6 7.2-5 .9-2.5.9-4.6.6-5-.3-.4-1-.7-2-1.2l-7.3-3.5c-1-.4-1.7-.5-2.4.5l-3.3 4c-.6.7-1.2.8-2.3.3-1.1-.5-4.5-1.7-8.5-5.3-3.2-2.8-5.3-6.3-5.9-7.3-.6-1.1-.1-1.6.5-2.2a16 16 0 0 0 1.6-1.9c.5-.6.7-1.1 1.1-1.8.4-.7.2-1.3-.1-1.9-.4-.4-2.5-5.6-3.4-7.7z" />
  </g>));
